import { Component, OnInit } from '@angular/core';
import { MemberSearchParams, UserDisplay, UserManagementService, UserStats } from '../user-management.service';
import { PageEvent } from '@angular/material/paginator';
import { PageResponse } from '../base-capacitor-http';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  page: PageResponse<UserDisplay> = new PageResponse<UserDisplay>;
  searchParams: MemberSearchParams;

  pageSizeOptions = [5, 10, 25];
  userStats: UserStats;
  bulkAction: boolean = false;
  modal: boolean = false;
  modalText: string;
  statusFilter: string = '';
  roleFilter: string = '';
  action: string = '';
  selectedUser: UserDisplay;
  private emailCheckTimeout: any;
  private usernameTimeout: any;
  emailExists: boolean = false;
  usernameExists: boolean = false;

  constructor(private userManagementService: UserManagementService, private utilService: UtilitieService) {
  }

  getAvatar(user: UserDisplay) {
    return user.username[0].toUpperCase() + user.username[1].toUpperCase();
  }

  selectAll() {
    this.page.data.forEach(user => {
      user.selected = !this.bulkAction;
    });
  }

  getSelectedCount() {
    return this.page.data.filter(member => { return member.selected === true }).length || 0;
  }

  async checkUsernameExists() {
    clearTimeout(this.usernameTimeout);
    this.usernameTimeout = setTimeout(async () => {
      this.usernameExists = await this.userManagementService.checkEmailExists(this.selectedUser.username);
    }, 500);
  }

  async checkEmailExists() {
    clearTimeout(this.emailCheckTimeout);
    this.emailCheckTimeout = setTimeout(async () => {
      this.emailExists = await this.userManagementService.checkEmailExists(this.selectedUser.email);
    }, 500);
  }

  async saveUser() {
    if (this.selectedUser.id) {
      const user = this.page.data.find(user => user.id === this.selectedUser.id);
      const index = this.page.data.indexOf(user);
      const result = await this.userManagementService.updateMember(this.selectedUser);
      this.page.data[index] = result;
      this.modal = false;
      this.utilService.openSnackBar('Member has been updated', 'OK');
      this.loadPageData();
      return;
    }

    const result = await this.userManagementService.registerMember(this.selectedUser);
    if (result !== null) {
      this.modal = false;
      this.utilService.openSnackBar('New member has been registered', 'OK');
      this.loadPageData();
      return;
    }

    this.utilService.openSnackBar('There was an issue creating new user, please try again.', 'OK');
  }

  clearSearchFilter() {
    this.statusFilter = null;
    this.searchParams.role = null;
    this.loadPageData();
  }

  async applyBulkAction() {
    const selectedUsers = this.page.data.filter(user => { return user.selected === true; });
    switch (this.action) {
      case 'enable':
        selectedUsers.forEach(user => { user.disabled = false; });
        this.userManagementService.bulkUpdate('enable', selectedUsers);
        break;
      case 'disable':
        selectedUsers.forEach(user => { user.disabled = true; });
        this.userManagementService.bulkUpdate('disable', selectedUsers);
        break;
      case 'delete':
        this.userManagementService.bulkUpdate('delete', selectedUsers);
        break;
      default:
        break;
    }
    this.loadPageData();
  }

  async search(){
    this.loadPageData();
  }

  async searchUsers() {

    this.searchParams.page = 0;
    if (this.roleFilter === '') {
      this.searchParams.role = null;
    } else {
      this.searchParams.role = this.roleFilter;
    }

    switch (this.statusFilter) {
      case 'active':
        this.searchParams.verified = true;
        this.searchParams.disabled = false;
        break;
      case 'verified':
        this.searchParams.verified = true;
        this.searchParams.disabled = null;
        break;
      case 'disabled':
        this.searchParams.disabled = true;
        this.searchParams.verified = null;
        break;
      default:
        this.searchParams.verified = null;
        this.searchParams.disabled = null;
        break;
    }

    this.loadPageData();
  }

  async handlePageEvent(e: PageEvent) {
    this.searchParams.size = e.pageSize;
    this.searchParams.page = e.pageIndex;
    this.loadPageData();
  }

  async loadPageData() {
    this.userStats = await this.userManagementService.getUserStats();
    this.page = await this.userManagementService.getAllMemberData(this.searchParams);
  }

  openModal() {
    this.modal = true;
    this.modalText = 'Add new user';
  }

  closeModal() {
    this.modal = false;
    this.selectedUser = new UserDisplay();
  }

  editUser(index: number) {
    this.modal = true;
    this.modalText = 'Edit user';
    this.selectedUser = this.page.data[index];
  }

  async toggleUserStatus(index: number) {
    let member = this.page.data[index];
    if (member.disabled === true) {
      member.disabled = false;
    } else {
      member.disabled = true;
    }

    member = await this.userManagementService.updateMember(member);
    this.page.data[index] = member;
  }

  async deleteUser(index: number) {
    const member = this.page.data[index];
    const result = await this.userManagementService.deleteMember(member.id);
    if (result) {
      this.loadPageData();
    }
  }

  async ngOnInit(): Promise<void> {
    this.searchParams = new MemberSearchParams();
    this.page = new PageResponse();
    this.selectedUser = new UserDisplay();
    this.loadPageData();
    this.utilService.updateLoading(false);
  }
}
